
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/material-ui/react-stack",
      function () {
        return require("private-next-pages/material-ui/react-stack.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/material-ui/react-stack"])
      });
    }
  